import {UrlBuilder} from "tools";
import {ApiRequest, PagedList, PagedListPayload} from "framework/api";
import {RulesConfiguration} from "controls/queryBuilder/ruleDefinition";
import {GridDataItem} from "controls/grid/gridDataItem";
import {DataSource} from "areas/data-sources/types/dataSource";
import {getDataSourcePayload} from "controls/designer/features/widgets/datasources/api";

const endpoint = 'dataSources';


export type GetDataSourcesArgs = {
	accountId?: string
	payload?: PagedListPayload
	includeSubaccounts?: boolean
}

export function getDataSources(args?: GetDataSourcesArgs) {
	return new ApiRequest<PagedList<GridDataItem<DataSource>>>({
		url: endpoint + '/summaryList',
		accountBased: true,
		accountId: args?.accountId,
		subaccountsFilter: true,
		includeSubaccounts: args.includeSubaccounts,
		method: 'POST',
		payload: args?.payload
	});
}

export type GetDataSourceArgs = {
	id: string,
	accountId?: string
}

export function getDataSource(args: GetDataSourceArgs) {
	return new ApiRequest<DataSource>({
		url: `${endpoint}/${args.id}`,
		accountBased: true,
		accountId: args?.accountId,
	});
}

export function getDataSourceFiltersConfiguration() {
	const urlBuilder = new UrlBuilder(`${endpoint}/summaryList/ruleConfiguration`);
	return new ApiRequest<RulesConfiguration>({
		url: urlBuilder.build(),
		accountBased: true,
		method: 'GET'
	})
}

export type GetDataSourceFiltersConfigurationArgs = {
	accountId: string
	dataSourceId: string
	requestId?: string
	// not pivoted
	categoryColumns?: string[]
	dataColumns?: string[]
	dataRows?: string[]
	// pivoted
	pivotRows?: string[]
	pivotColumns?: string[]
	pivotValues?: string[]
	pivotData?: boolean
	pivotMatrix?: boolean
	splitPivotValues?: boolean
}

export function getDataSourceDataFiltersConfiguration(args: GetDataSourceFiltersConfigurationArgs) {
	const urlBuilder = new UrlBuilder(`dataSources/${args.dataSourceId}/ruleConfiguration`);
	return new ApiRequest<RulesConfiguration>({
		url: urlBuilder.build(),
		accountId: args.accountId,
		accountBased: true,
		method: 'POST',
		payload: getDataSourcePayload(args),
	})
}

export type GetDataSourceDataArgs = GetDataSourceFiltersConfigurationArgs

export function getDataSourceData(args: GetDataSourceDataArgs) {
	return new ApiRequest<PagedList<GridDataItem<any>>>({
		url: `dataSources/${args.dataSourceId}/data`,
		accountBased: true,
		accountId: args.accountId,
		method: 'POST',
		payload: getDataSourcePayload(args),
	})
}
